/* eslint-disable jsx-a11y/anchor-has-content */
// Report layout V1 - the original Employer Partner report (questionnaire types other than 2).
//
// Data loading, saving and the AI calls live in ReportBase.
import React from "react";
import { Helmet } from "react-helmet";
import {
  ReportCategoryChart,
  ReportCategoryHightlightsSuggestions,
  ReportChart,
  ReportConfirmation,
  ReportContent,
  ReportCover,
  ReportHighlights,
  ReportIndex,
  ReportInfo,
  ReportIntro,
  ReportOutro,
  ReportOveral,
  ReportEducations,
  ReportForEmployer,
  ReportTimeline,
  ReportBenchmark,
  ReportCustomBenchmark,
} from "../../components/report";
import {
  BarChart,
  Bar,
  ComposedChart,
  LabelList,
  Legend,
  ReferenceLine,
  XAxis,
  YAxis,
} from "recharts";
import { ReportCircleChart } from "../../components/report/components";
import {
  audit,
  whatsNext,
} from "../../components/report/components/ReportTemplates";
import { getCountries, getLanguage } from "../../utils/utils";
import classNames from "classnames";
import "../css/report.css";

import ReportFullInput from "../../components/report/ReportFullInput";
import { NavLink } from "react-router-dom";
import { Loader } from "../../components";
import ReportLegend from "../../components/report/ReportLegend";
import ReportBase from "./ReportBase";
import ReportAboveBeyond from "./ReportAboveBeyond";

export default class ReportV1 extends ReportBase {
  renderReport() {
    const {
      id,
      ab,
      benchmarkCountry,
      benchmarkIndustry,
      benchmarkGroup,
      benchmarkLoading,
      categories,
      content,
      data,
      editable,
      messages,
      aiItems,
      aiLoading,
    } = this.state;

    if (!data) {
      return <div className="loading">{messages.loading}</div>;
    }

    return (
      <div className="page__wrapper">
        {!editable && (
          <div className="page__notice">{messages.reportLocked}</div>
        )}
        <div className="page__report">
          <h2>{messages.report}</h2>
          <Helmet>
            <title>{data.info.name} - Employer Partner</title>
          </Helmet>
          <div className="backlink">
            <NavLink to={`/${id}`} />
          </div>
          {data.info.advanced === 1 && (
            <div className="report__tabs">
              <span
                className={classNames("button", { "button--light": ab })}
                onClick={() => this.setState({ ab: false })}
              >
                {messages.employerPartner}
              </span>
              <span
                className={classNames("button", { "button--light": !ab })}
                onClick={() => this.setState({ ab: true })}
              >
                {messages.aboveBeyond}
              </span>
            </div>
          )}
          <div className="report__print">
            <button className="button" onClick={() => window.print()}>
              {messages.download}
            </button>
          </div>

          {ab && (
            <ReportAboveBeyond
              content={content}
              data={data}
              editable={editable}
              messages={messages}
              onContentChange={this._contentOnChange}
            />
          )}

          {!ab && (
            <>
              <ReportCover
                editable={editable}
                info={data.info}
                content={content}
                onChange={this._contentOnChange}
              />
              <ReportIndex passed={data.info.passed} />
              {!data.info.passed && (
                <>
                  <ReportContent
                    id="page-selectio"
                    background="/assets/images/report-bg-logo.png"
                  >
                    <div
                      style={{ fontSize: "0.8rem", padding: "0 0 0 320px" }}
                      dangerouslySetInnerHTML={{
                        __html: audit.about[getLanguage()],
                      }}
                    />
                  </ReportContent>
                </>
              )}

              <ReportContent>
                <div>
                  <img
                    style={{ maxWidth: "100%" }}
                    alt=""
                    src={`/assets/images/temp-grow-${getLanguage()}.png`}
                  />
                </div>
              </ReportContent>
              {data.info.passed && (
                <>
                  <ReportForEmployer />
                  <ReportIntro />
                </>
              )}
              {!data.info.passed && (
                <>
                  <ReportContent
                    id="page-hr-analysis"
                    background={`/assets/images/report-infochart-right-${getLanguage()}.png`}
                  >
                    <div
                      style={{
                        fontSize: "0.9rem",
                        padding: "0 360px 0 0",
                        width: "700px",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: audit.hrAnalysis[getLanguage()],
                      }}
                    />
                  </ReportContent>
                  <ReportContent
                    id="page-structural-overview"
                    background={`/assets/images/report-infochart-${getLanguage()}.png`}
                  >
                    <div
                      style={{
                        fontSize: "0.9rem",
                        padding: "0 0 0 450px",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: audit.structuralOverview[getLanguage()],
                      }}
                    />
                  </ReportContent>
                  <ReportContent
                    id="page-winners"
                    background={`/assets/images/report-audit-5-${getLanguage()}.png`}
                  ></ReportContent>
                </>
              )}
              <ReportInfo />
              {/*
              <ReportContent>
                <h2 style={{ margin: '0 0 -15px 0', zIndex: 2 }}>Current award holders</h2>
                <div>
                  <img
                    style={{ maxWidth: "100%" }}
                    alt=""
                    src="/assets/images/report-holders.png"
                  />
                </div>
              </ReportContent>
              */}

              <ReportContent
                hideBadge={true}
                id="page-your-result"
                background="/assets/images/report-cover-blue.jpg"
              >
                <div
                  style={{
                    color: "#fff",
                    padding: "0 0 0 0",
                    width: "400px",
                  }}
                >
                  <h2>{messages.yourResults}</h2>
                  <p>{messages.yourResultsIntro}</p>
                </div>
              </ReportContent>
              <ReportOveral
                title={messages.overallResult}
                description={messages.overallResultIntro}
              >
                <ReportCircleChart
                  value={data.result.overal}
                  previousValue={data.result.previous}
                  size={260}
                  stroke={40}
                  showLine={true}
                />
                {data.result.previous && (
                  <ReportLegend
                    first={data.info.year}
                    second={data.info.previousYear}
                  />
                )}
              </ReportOveral>
              <ReportChart
                id="page-result-benchmark"
                title={messages.overallResult}
                subtitle={messages.benchmarkAnalysis}
                className="report_chart--overall"
                options={
                  <div className="report__options">
                    <div className="report__benchmark">
                      <h3>{messages.benchmarkTitle}</h3>
                      <form method="post" onSubmit={this._benchmarkOnSubmit}>
                        <fieldset className="fieldset">
                          <label className="label">{messages.country}</label>
                          <select
                            name="benchmarkCountry"
                            className="input"
                            onChange={this._benchmarkOnChange}
                          >
                            <option value="">-</option>
                            {getCountries().map((item, key) => (
                              <option key={key} value={item}>
                                {messages.countries[item]}
                              </option>
                            ))}
                          </select>
                        </fieldset>
                        <fieldset className="fieldset">
                          <label className="label">{messages.industry}</label>
                          <select
                            name="benchmarkIndustry"
                            className="input input--medium"
                            onChange={this._benchmarkOnChange}
                          >
                            <option value="">-</option>
                            {categories.map((item, key) => (
                              <option key={key} value={item.id}>
                                {messages.primaryBusinessType[item.id]}
                              </option>
                            ))}
                          </select>
                        </fieldset>
                        {data.info.company.group && (
                          <fieldset className="fieldset">
                            <label className="label">
                              {messages.companyGroup}
                            </label>
                            <select
                              name="benchmarkGroup"
                              className="input input--medium"
                              onChange={this._benchmarkOnChange}
                            >
                              <option value="">-</option>
                              <option value="1">{messages.show}</option>
                            </select>
                          </fieldset>
                        )}
                        <fieldset>
                          {benchmarkLoading ? (
                            <Loader />
                          ) : (
                            <button className="button">
                              {messages.benchmarkSubmit}
                            </button>
                          )}
                        </fieldset>
                      </form>
                    </div>
                  </div>
                }
              >
                {benchmarkLoading ? (
                  <Loader />
                ) : (
                  <ComposedChart
                    width={500}
                    height={300}
                    data={[
                      {
                        name: "",
                        grade: data.result.overal,
                        others: data.result.average,
                        benchmarkCountry: data.result.benchmarkCountry,
                        benchmarkIndustry: data.result.benchmarkIndustry,
                        benchmarkGroup: data.result.benchmarkGroup,
                      },
                    ]}
                  >
                    <Bar
                      name={messages.yourOrganization}
                      dataKey="grade"
                      fill="#3dc5f1"
                    >
                      <LabelList
                        position="inside"
                        formatter={(value) => `${value}%`}
                      />
                    </Bar>
                    <Bar
                      name={messages.employerPartnerAvg}
                      dataKey="others"
                      fill="#eaeaea"
                    >
                      <LabelList
                        position="inside"
                        formatter={(value) => `${value}%`}
                      />
                    </Bar>

                    {benchmarkCountry && (
                      <Bar
                        name={messages.countries[this.state.benchmarkCountry]}
                        dataKey="benchmarkCountry"
                        fill="#022E49"
                      >
                        <LabelList
                          position="inside"
                          style={{ fill: "#fff" }}
                          formatter={(value) => `${value}%`}
                        />
                      </Bar>
                    )}

                    {benchmarkIndustry && (
                      <Bar
                        name={
                          messages.primaryBusinessType[
                            this.state.benchmarkIndustry
                          ]
                        }
                        dataKey="benchmarkIndustry"
                        fill="#56C4C4"
                      >
                        <LabelList
                          position="inside"
                          formatter={(value) => `${value}%`}
                        />
                      </Bar>
                    )}

                    {benchmarkGroup && (
                      <Bar
                        name={messages.companyGroup}
                        dataKey="benchmarkGroup"
                        fill="#56C4C4"
                      >
                        <LabelList
                          position="inside"
                          formatter={(value) => `${value}%`}
                        />
                      </Bar>
                    )}

                    <XAxis type="category" dataKey="name" width={200} />
                    <YAxis type="number" domain={[0, 100]} />
                    <Legend
                      align="left"
                      wrapperStyle={{ left: 64 }}
                      formatter={(value, entry, index) => (
                        <span className="report__legend__label">{value}</span>
                      )}
                    />
                    <ReferenceLine y="75" stroke="#ea3158" />
                  </ComposedChart>
                )}
              </ReportChart>

              <ReportChart
                id="page-key-topics"
                title={messages.resultsKeyTopics}
                description={messages.resultsKeyTopicsDescription}
              >
                <ComposedChart
                  width={500}
                  height={350}
                  data={data.keyTopics}
                  layout="vertical"
                >
                  <XAxis
                    type="number"
                    domain={[0, 3]}
                    ticks={[0, 0.5, 1, 1.5, 2, 2.5, 3]}
                  />
                  <Bar name={data.info.year} dataKey="grade" fill="#3dc5f1" />
                  <YAxis type="category" dataKey="content" width={200} />
                  <ReferenceLine x="2" stroke="#ea3158" />
                  {data.info.previousYear && (
                    <>
                      <Bar
                        name={data.info.previousYear}
                        dataKey="previousGrade"
                        fill="#014e7d"
                      />
                      <Legend
                        align="left"
                        wrapperStyle={{ left: 204 }}
                        formatter={(value, entry, index) => (
                          <span className="report__legend__label">{value}</span>
                        )}
                      />
                    </>
                  )}
                </ComposedChart>
              </ReportChart>

              <ReportChart
                id="page-key-topics-benchmark"
                title={messages.resultsKeyTopics}
                subtitle={messages.benchmarkAnalysis}
              >
                <ComposedChart
                  width={500}
                  height={350}
                  data={data.keyTopics}
                  layout="vertical"
                >
                  <Bar
                    name={messages.yourOrganization}
                    dataKey="grade"
                    fill="#3dc5f1"
                  />
                  <Bar
                    name={messages.employerPartnerAvg}
                    dataKey="others"
                    fill="#eaeaea"
                  />

                  {benchmarkCountry && (
                    <Bar
                      name={messages.countries[this.state.benchmarkCountry]}
                      dataKey="benchmarkCountry"
                      fill="#022E49"
                    />
                  )}

                  {benchmarkIndustry && (
                    <Bar
                      name={
                        messages.primaryBusinessType[
                          this.state.benchmarkIndustry
                        ]
                      }
                      dataKey="benchmarkIndustry"
                      fill="#56C4C4"
                    />
                  )}

                  {benchmarkGroup && (
                    <Bar
                      name={messages.companyGroup}
                      dataKey="benchmarkGroup"
                      fill="#56C4C4"
                    />
                  )}

                  <XAxis
                    type="number"
                    domain={[0, 3]}
                    ticks={[0, 0.5, 1, 1.5, 2, 2.5, 3]}
                  />
                  <YAxis type="category" dataKey="content" width={200} />
                  <ReferenceLine x="2" stroke="#ea3158" />
                  <Legend
                    align="left"
                    wrapperStyle={{ left: 204 }}
                    formatter={(value, entry, index) => (
                      <span className="report__legend__label">{value}</span>
                    )}
                  />
                </ComposedChart>
              </ReportChart>

              <ReportChart
                id="page-elc"
                title={messages.resultsELCSteps}
                description=""
              >
                <BarChart
                  margin={{ top: 15, right: 5, bottom: 5, left: 5 }}
                  width={500}
                  height={400}
                  data={data.categories}
                >
                  <Bar name={data.info.year} dataKey="grade" fill="#3dc5f1">
                    <LabelList
                      position="top"
                      formatter={(value) => `${value}%`}
                    />
                  </Bar>
                  <XAxis
                    type="category"
                    dataKey="content"
                    width={200}
                    interval={0}
                    height={140}
                    angle="-60"
                    textAnchor="end"
                  />
                  <YAxis type="number" domain={[0, 100]} />

                  {data.info.previousYear && (
                    <>
                      <Bar
                        name={data.info.previousYear}
                        dataKey="previousGrade"
                        fill="#014e7d"
                      >
                        <LabelList
                          position="top"
                          formatter={(value) => `${value}%`}
                        />
                      </Bar>
                      <Legend
                        align="left"
                        wrapperStyle={{ left: 64 }}
                        formatter={(value, entry, index) => (
                          <span className="report__legend__label">{value}</span>
                        )}
                      />
                    </>
                  )}
                </BarChart>
              </ReportChart>
              <ReportChart
                id="page-elc-benchmark"
                title={messages.resultsELCSteps}
                description={messages.benchmarkAnalysis}
              >
                <BarChart
                  margin={{ top: 15, right: 5, bottom: 5, left: 5 }}
                  width={500}
                  height={400}
                  data={data.categories}
                >
                  <Bar
                    name={messages.yourOrganization}
                    dataKey="grade"
                    fill="#3dc5f1"
                  >
                    <LabelList
                      position="top"
                      formatter={(value) => `${value}%`}
                    />
                  </Bar>
                  <Bar
                    name={messages.employerPartnerAvg}
                    dataKey="others"
                    fill="#eaeaea"
                  >
                    <LabelList
                      position="top"
                      formatter={(value) => `${value}%`}
                    />
                  </Bar>

                  {benchmarkCountry && (
                    <Bar
                      name={messages.countries[benchmarkCountry]}
                      dataKey="benchmarkCountry"
                      fill="#022E49"
                    >
                      <LabelList
                        position="top"
                        formatter={(value) => `${value}%`}
                      />
                    </Bar>
                  )}

                  {benchmarkIndustry && (
                    <Bar
                      name={messages.primaryBusinessType[benchmarkIndustry]}
                      dataKey="benchmarkIndustry"
                      fill="#56C4C4"
                    >
                      <LabelList
                        position="top"
                        formatter={(value) => `${value}%`}
                      />
                    </Bar>
                  )}

                  {benchmarkGroup && (
                    <Bar
                      name={messages.companyGroup}
                      dataKey="benchmarkGroup"
                      fill="#56C4C4"
                    >
                      <LabelList
                        position="top"
                        formatter={(value) => `${value}%`}
                      />
                    </Bar>
                  )}

                  <XAxis
                    type="category"
                    dataKey="content"
                    width={200}
                    interval={0}
                    height={140}
                    angle="-60"
                    textAnchor="end"
                  />
                  <YAxis type="number" domain={[0, 100]} />
                  <Legend
                    align="left"
                    wrapperStyle={{ left: 64 }}
                    formatter={(value, entry, index) => (
                      <span className="report__legend__label">{value}</span>
                    )}
                  />
                </BarChart>
              </ReportChart>
              <ReportChart
                id="page-steps"
                title={messages.resultsDiveIn}
                description={messages.resultsDiveInDescription}
                className="report__page--dark"
              />

              {data.categories.map((item, key) => {
                let barSize = 15;
                if (benchmarkCountry) barSize -= 5;
                if (benchmarkIndustry) barSize -= 5;
                if (benchmarkGroup) barSize -= 5;
                if (data.info.previousYear) barSize -= 5;

                return (
                  <div key={key}>
                    <ReportCategoryChart
                      title={item.content}
                      value={item.grade}
                      previousValue={item.previousGrade}
                    >
                      <BarChart
                        width={550}
                        height={50 + item.areas.length * 60}
                        data={item.areas}
                        layout="vertical"
                      >
                        <Bar
                          name={
                            data.info.previousYear
                              ? data.info.year
                              : messages.yourOrganization
                          }
                          dataKey="grade"
                          fill="#3dc5f1"
                          barSize={barSize}
                        />

                        {data.info.previousYear && (
                          <Bar
                            name={data.info.previousYear}
                            dataKey="previousGrade"
                            fill="#014e7d"
                            barSize={barSize}
                          />
                        )}

                        <Bar
                          name={messages.employerPartnerAvg}
                          dataKey="others"
                          fill="#eaeaea"
                          barSize={barSize}
                        />

                        {benchmarkCountry && (
                          <Bar
                            name={
                              messages.countries[this.state.benchmarkCountry]
                            }
                            dataKey="benchmarkCountry"
                            fill="#022E49"
                            barSize={barSize}
                          />
                        )}

                        {benchmarkIndustry && (
                          <Bar
                            name={
                              messages.primaryBusinessType[
                                this.state.benchmarkIndustry
                              ]
                            }
                            dataKey="benchmarkIndustry"
                            fill="#56C4C4"
                            barSize={barSize}
                          />
                        )}

                        {benchmarkGroup && (
                          <Bar
                            name={messages.companyGroup}
                            dataKey="benchmarkGroup"
                            fill="#56C4C4"
                            barSize={barSize}
                          />
                        )}

                        <XAxis
                          type="number"
                          domain={[0, 3]}
                          ticks={[0, 0.5, 1, 1.5, 2, 2.5, 3]}
                        />
                        <YAxis type="category" dataKey="content" width={200} />
                        <Legend
                          align="left"
                          wrapperStyle={{ left: 204 }}
                          formatter={(value, entry, index) => (
                            <span className="report__legend__label">
                              {value}
                            </span>
                          )}
                        />
                      </BarChart>
                    </ReportCategoryChart>
                    <ReportCategoryHightlightsSuggestions
                      heading={messages.highlights}
                      name={`highlights_${item.id}`}
                      title={item.content}
                      score={item.grade}
                      previousScore={item.previousGrade}
                      content={content[`highlights_${item.id}`]}
                      onChange={this._contentOnChange}
                      suggestions={item.highlights}
                      editable={editable}
                      aiHeading={messages.aiHighlightsHeading}
                      aiButtonLabel={messages.getAiHighlights}
                      aiItems={aiItems[`highlights_${item.id}`]}
                      aiLoading={aiLoading[`highlights_${item.id}`]}
                      onGetAi={() => this._getAiItems(item.id, "highlights")}
                    />
                    <ReportCategoryHightlightsSuggestions
                      heading={messages.suggestions}
                      name={`suggestions_${item.id}`}
                      title={item.content}
                      score={item.grade}
                      previousScore={item.previousGrade}
                      content={content[`suggestions_${item.id}`]}
                      onChange={this._contentOnChange}
                      suggestions={item.suggestions}
                      editable={editable}
                      aiHeading={messages.aiSuggestionsHeading}
                      aiButtonLabel={messages.getAiSuggestions}
                      aiItems={aiItems[`suggestions_${item.id}`]}
                      aiLoading={aiLoading[`suggestions_${item.id}`]}
                      onGetAi={() => this._getAiItems(item.id, "suggestions")}
                    />
                    {!data.info.passed && (
                      <ReportCategoryHightlightsSuggestions
                        heading={messages.suggestions}
                        name={`suggestions_additional_${item.id}`}
                        title={item.content}
                        score={item.grade}
                        previousScore={item.previousGrade}
                        content={content[`suggestions_additional_${item.id}`]}
                        onChange={this._contentOnChange}
                        suggestions={item.suggestions}
                        editable={editable}
                      />
                    )}
                  </div>
                );
              })}

              <ReportHighlights
                id="page-care-highlights"
                title={messages.yourCareTitleMultiline}
                onChange={this._contentOnChange}
                name="highlightsFirst"
                value={content.highlightsFirst}
                suggestions={data.highlights.filter(
                  (item) => item.grade >= 3 || item.grade === null
                )}
                editable={editable}
              />

              {data.info.passed && (
                <ReportHighlights
                  id="page-care-highlights2"
                  title={messages.yourCareTitleMultiline}
                  onChange={this._contentOnChange}
                  name="highlightsSecond"
                  value={content.highlightsSecond}
                  suggestions={data.highlights.filter(
                    (item) => item.grade >= 3 || item.grade === null
                  )}
                  editable={editable}
                />
              )}

              <ReportHighlights
                id="page-care-suggestions"
                type="dimmed"
                title={messages.keepInMindTitle}
                onChange={this._contentOnChange}
                name="suggestions"
                value={content.suggestions}
                suggestions={data.highlights.filter(
                  (item) => item.grade < 3 && item.grade !== null
                )}
                editable={editable}
              />

              {!data.info.passed && (
                <ReportHighlights
                  id="page-care-suggestions-additional"
                  type="dimmed"
                  title={messages.keepInMindTitle}
                  onChange={this._contentOnChange}
                  name="suggestionsAdditional"
                  value={content.suggestionsAdditional}
                  suggestions={data.highlights.filter(
                    (item) => item.grade < 3 && item.grade !== null
                  )}
                  editable={editable}
                />
              )}

              <ReportContent
                id="page-care-benchmark"
                title={messages.yourCareTitle}
                subtitle={messages.benchmarkAnalysis}
              >
                <ReportCustomBenchmark
                  benchmarks={data.benchmarks}
                  labelAverage={messages.employerPartnerAvg}
                />
              </ReportContent>
              <ReportBenchmark
                benchmarkLabel={messages.employerPartnerAvg}
                title={messages.yourCareTitle}
                subtitle={messages.benchmarkAnalysis}
                messages={messages}
                data={data.benchmarksPercentage.slice(0, 9)}
              />
              <ReportBenchmark
                benchmarkLabel={messages.employerPartnerAvg}
                title={messages.yourCareTitle}
                subtitle={messages.benchmarkAnalysis}
                messages={messages}
                data={data.benchmarksPercentage.slice(9)}
              />

              <ReportEducations
                id="educations"
                editable={editable}
                title={messages.educationTitle}
                subtitle={messages.educationIntro}
                content={content.educations ? content.educations : ""}
                onChange={this._contentOnChange}
                suggestions={data.educations}
              />

              {data.info.passed ? (
                <>
                  <ReportConfirmation certifiers={data.certifiers} />
                  <ReportFullInput
                    editable={editable}
                    id="page-whatsnext"
                    name="whatsNext"
                    title={messages.whatsNext}
                    defaultValue={
                      content.whatsNext
                        ? content.whatsNext
                        : whatsNext[getLanguage()]
                    }
                    onChange={this._contentOnChange}
                  />
                </>
              ) : (
                <>
                  <ReportContent
                    hideBadge={true}
                    id="page-key-activities"
                    background="/assets/images/report-cover-blue.jpg"
                  >
                    <div
                      style={{
                        color: "#fff",
                        padding: "0 0 0 0",
                        width: "400px",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: audit.keyActivities[getLanguage()],
                      }}
                    />
                  </ReportContent>
                  <ReportFullInput
                    editable={editable}
                    id="page-strengths-strategy"
                    name="strengthsStrategy"
                    title={messages.strengthsStrategy}
                    defaultValue={
                      content.strengthsStrategy ? content.strengthsStrategy : ""
                    }
                    onChange={this._contentOnChange}
                  />
                  <ReportFullInput
                    editable={editable}
                    id="page-activities-strategy"
                    name="activitiesStrategy"
                    title={messages.neededActivitiesStrategy}
                    defaultValue={
                      content.activitiesStrategy
                        ? content.activitiesStrategy
                        : ""
                    }
                    onChange={this._contentOnChange}
                  />
                  <ReportFullInput
                    editable={editable}
                    id="page-strengths-investment"
                    name="strengthsInvestment"
                    title={messages.strengthsInvestment}
                    defaultValue={
                      content.strengthsInvestment
                        ? content.strengthsInvestment
                        : ""
                    }
                    onChange={this._contentOnChange}
                  />
                  <ReportFullInput
                    editable={editable}
                    id="page-activities-investment"
                    name="activitiesInvestment"
                    title={messages.neededActivitiesInvestment}
                    defaultValue={
                      content.activitiesInvestment
                        ? content.activitiesInvestment
                        : ""
                    }
                    onChange={this._contentOnChange}
                  />
                  <ReportFullInput
                    editable={editable}
                    id="page-strengths-processes"
                    name="strengthsProcesses"
                    title={messages.strengthsProcesses}
                    defaultValue={
                      content.strengthsProcesses
                        ? content.strengthsProcesses
                        : ""
                    }
                    onChange={this._contentOnChange}
                  />
                  <ReportFullInput
                    editable={editable}
                    id="page-activities-processes"
                    name="activitiesProcesses"
                    title={messages.neededActivitiesHr}
                    defaultValue={
                      content.activitiesProcesses
                        ? content.activitiesProcesses
                        : ""
                    }
                    onChange={this._contentOnChange}
                  />

                  <ReportContent
                    hideBadge={true}
                    id="page-action-plan"
                    background="/assets/images/report-cover-blue.jpg"
                  >
                    <div
                      style={{
                        color: "#fff",
                        padding: "0 0 0 0",
                        width: "400px",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: audit.actionPlanAndTimeline[getLanguage()],
                      }}
                    />
                  </ReportContent>
                  <ReportFullInput
                    editable={editable}
                    id="page-action-plan"
                    name="actionPlan"
                    title={messages.actionPlanPriorities}
                    defaultValue={content.actionPlan ? content.actionPlan : ""}
                    onChange={this._contentOnChange}
                  />
                  <ReportFullInput
                    editable={editable}
                    id="page-action-plan-timeline"
                    name="actionPlanTimeline"
                    title={messages.actionPlanTimeline}
                    defaultValue={
                      content.actionPlanTimeline
                        ? content.actionPlanTimeline
                        : ""
                    }
                    onChange={this._contentOnChange}
                  />
                  <ReportContent
                    hideBadge={true}
                    id="page-change-management"
                    background="/assets/images/report-cover-blue.jpg"
                  >
                    <div
                      style={{
                        color: "#fff",
                        padding: "0 0 0 0",
                        width: "400px",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: audit.changeManagement[getLanguage()],
                      }}
                    />
                  </ReportContent>
                  <ReportContent background="/assets/images/report-bg-logo.png">
                    <div
                      style={{ fontSize: "0.8rem", padding: "0 100px 0 320px" }}
                      dangerouslySetInnerHTML={{
                        __html: audit.agilityHrProcess[getLanguage()],
                      }}
                    />
                  </ReportContent>
                  <ReportContent
                    hideBadge={true}
                    id="page-roles"
                    background="/assets/images/report-cover-blue.jpg"
                  >
                    <div
                      style={{
                        color: "#fff",
                        padding: "0 0 0 0",
                        width: "400px",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: audit.roles[getLanguage()],
                      }}
                    />
                  </ReportContent>
                  <ReportContent
                    background={`/assets/images/report-audit-9-${getLanguage()}.png`}
                  ></ReportContent>
                  <ReportContent background="/assets/images/report-audit-10.png">
                    <div
                      style={{ fontSize: "0.8rem", padding: "0 320px 0 0" }}
                      dangerouslySetInnerHTML={{
                        __html: audit.rolesInfo[getLanguage()],
                      }}
                    />
                  </ReportContent>
                  <ReportContent background="/assets/images/report-audit-11.png">
                    <div
                      style={{ fontSize: "0.8rem", padding: "0 0 0 320px" }}
                      dangerouslySetInnerHTML={{
                        __html: audit.boardRole[getLanguage()],
                      }}
                    />
                  </ReportContent>
                  <ReportContent background="/assets/images/report-audit-12.png">
                    <div
                      style={{ fontSize: "0.8rem", padding: "0 320px 0 0" }}
                      dangerouslySetInnerHTML={{
                        __html: audit.hrRole[getLanguage()],
                      }}
                    />
                  </ReportContent>
                  <ReportContent background="/assets/images/report-audit-13.png">
                    <div
                      style={{ fontSize: "0.8rem", padding: "0 0 0 320px" }}
                      dangerouslySetInnerHTML={{
                        __html: audit.managerRole[getLanguage()],
                      }}
                    />
                  </ReportContent>
                  <ReportContent
                    hideBadge={true}
                    background="/assets/images/report-bg-logo-right.png"
                  >
                    <div
                      style={{ fontSize: "0.8rem", padding: "0 320px 0 0" }}
                      dangerouslySetInnerHTML={{
                        __html: audit.competenceCulture[getLanguage()],
                      }}
                    />
                  </ReportContent>
                  <ReportContent background="/assets/images/report-bg-logo.png">
                    <div
                      style={{ fontSize: "0.8rem", padding: "0 100px 0 320px" }}
                      dangerouslySetInnerHTML={{
                        __html: audit.developmentHr[getLanguage()],
                      }}
                    />
                  </ReportContent>
                  <ReportContent background="/assets/images/report-bg-logo.png">
                    <div
                      style={{ fontSize: "0.8rem", padding: "0 100px 0 320px" }}
                      dangerouslySetInnerHTML={{
                        __html: audit.measureHr[getLanguage()],
                      }}
                    />
                  </ReportContent>
                  <ReportContent
                    hideBadge={true}
                    background="/assets/images/report-bg-logo-right.png"
                  >
                    <div
                      style={{ fontSize: "0.8rem", padding: "0 350px 0 0" }}
                      dangerouslySetInnerHTML={{
                        __html: audit.developmentBoard[getLanguage()],
                      }}
                    />
                  </ReportContent>
                  <ReportContent
                    hideBadge={true}
                    background="/assets/images/report-bg-logo-right.png"
                  >
                    <div
                      style={{ fontSize: "0.8rem", padding: "0 350px 0 0" }}
                      dangerouslySetInnerHTML={{
                        __html: audit.measureBoard[getLanguage()],
                      }}
                    />
                  </ReportContent>

                  <ReportContent
                    hideBadge={true}
                    id="page-risks"
                    background="/assets/images/report-cover-blue.jpg"
                  >
                    <div
                      style={{
                        color: "#fff",
                        padding: "0 0 0 0",
                        width: "400px",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: audit.risks[getLanguage()],
                      }}
                    />
                  </ReportContent>
                  <div className="report__risks">
                    {[...Array(10)].map((x, i) => (
                      <ReportContent
                        additionalClass="report__section--padding report_midtitle_section"
                        background="/assets/images/report-background-blue-left.png"
                      >
                        <div className="report_midtitle">
                          {messages.statusQuoRisks}
                        </div>
                        <div
                          style={{ fontSize: "0.8rem" }}
                          dangerouslySetInnerHTML={{
                            __html: audit[`risks${i}`][getLanguage()],
                          }}
                        />
                      </ReportContent>
                    ))}
                  </div>
                  <ReportConfirmation certifiers={data.certifiers} />
                </>
              )}

              <ReportTimeline
                editable={editable}
                passed={data.info.passed}
                date={data.info.date}
                content={content.timeline}
                onChange={this._contentOnChange}
              />
              <ReportOutro
                title={
                  data.info.passed
                    ? messages.outroTitle
                    : messages.outroAuditTitle
                }
                sponsorsLabel={messages.sponsorsLabel}
                partnersLabel={messages.partnersLabel}
              />
            </>
          )}
        </div>
      </div>
    );
  }
}
